export default function componentTypes() {
  return [
    {
      key: 'Container',
      label: 'Component Container',
      group: 'Layout',
      buttonIcon: 'bi:box',
      hasNoValue: true,
    },
    {
      key: 'PlainText',
      label: 'Plain Text',
      group: 'Static Display',
      buttonIcon: 'fluent:text-24-regular',
      hasNoValue: true,
    },
    {
      key: 'RichText',
      label: 'Rich Text',
      group: 'Static Display',
      buttonIcon: 'fluent:text-add-24-regular',
      hasNoValue: true,
    },
    {
      key: 'CustomHTML',
      label: 'Custom HTML',
      group: 'Static Display',
      buttonIcon: 'fluent:text-add-24-regular',
      hasNoValue: true,
    },
    {
      key: 'RichTextMarkdown',
      label: 'Rich Text Markdown',
      group: 'Static Display',
      buttonIcon: 'fluent:text-add-24-regular',
      hasNoValue: true,
    },
    {
      key: 'MediaImage',
      label: 'Image / GIF',
      group: 'Static Display',
      buttonIcon: 'akar-icons:image',
      hasNoValue: true,
    },
    {
      key: 'MediaEmbed',
      label: 'Video / Embed',
      group: 'Static Display',
      buttonIcon: 'fluent:video-clip-20-regular',
      hasNoValue: true,
    },
    {
      key: 'Lottie',
      label: 'Lottie Player',
      group: 'Static Display',
      buttonIcon: 'uil:lottiefiles',
      hasNoValue: true,
    },
    {
      key: 'InputBox',
      label: 'Input',
      group: 'User Input',
      buttonIcon: 'ic:twotone-input',
    },
    {
      key: 'OptionSelector',
      label: 'Option Selector',
      group: 'User Input',
      buttonIcon: 'vaadin:options',
      hideFromCreator: true,
    },
    {
      key: 'FileUpload',
      label: 'File Upload',
      group: 'User Input',
      buttonIcon: 'ri:file-upload-line',
    },
    {
      key: 'CustomButton',
      label: 'Button',
      group: 'User Input',
      buttonIcon: 'dashicons:button',
      hasTriggers: true,
    },
    {
      key: 'BookMeeting',
      label: 'Book Meeting',
      group: 'Integrations',
      buttonIcon: '',
      hasTriggers: true,
      hideFromCreator: true,
    },
    {
      key: 'StripeCheckout',
      label: 'Stripe Checkout',
      group: 'Integrations',
      buttonIcon: 'ph:stripe-logo',
      hasTriggers: true,
    },
    {
      key: 'PaypalCheckout',
      label: 'Paypal Checkout',
      group: 'Integrations',
      buttonIcon: 'ph:paypal-logo',
      hasTriggers: true,
    },
    {
      key: 'RegisterForMeeting',
      label: 'Register For Meeting',
      group: 'Advanced',
      buttonIcon: 'zondicons:inbox-check',
    },
    {
      key: 'CustomAuth',
      label: 'Custom Auth',
      group: 'Advanced',
      buttonIcon: 'carbon:two-factor-authentication',
    },
    {
      key: 'ProgressBar',
      label: 'Savvy Progress Bar',
      group: 'Savvy Presets',
      buttonIcon: '',
      hasNoValue: true,
    },
    {
      key: 'FlowFooter',
      label: 'Footer',
      group: 'Savvy Presets',
      buttonIcon: '',
      noEditor: true,
      hasNoValue: true,
    },
    {
      key: 'PrevFooterButton',
      label: 'Prev Footer Button',
      group: 'Savvy Presets',
      buttonIcon: 'dashicons:button',
      hasNoValue: true,
    },
    {
      key: 'NextFooterButton',
      label: 'Next Footer Button',
      group: 'Savvy Presets',
      buttonIcon: 'dashicons:button',
      hasNoValue: true,
    },
    {
      key: 'PageTitle',
      label: 'Page Title',
      group: 'Savvy Presets',
      buttonIcon: 'fluent:text-24-regular',
      hasNoValue: true,
    },
    {
      key: 'PageSubtitle',
      label: 'Page Subtitle',
      group: 'Savvy Presets',
      buttonIcon: 'fluent:text-24-regular',
      hasNoValue: true,
    },
    {
      key: 'PageHeadingLabel',
      label: 'Page Heading Label',
      group: 'Savvy Presets',
      buttonIcon: 'fluent:text-24-regular',
      hasNoValue: true,
    },
    {
      key: 'PlaceholderComponent',
      label: 'Placeholder Component',
      group: 'Savvy Presets',
      buttonIcon: 'fluent:text-24-regular',
      noEditor: true,
      hasNoValue: true,
    },
  ]
}
